'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generic component to indicate that there is no data.
 *
 * @param  {ReactElement} props.children
 *
 * @param  {String} props.icon
 * The icon to display.
 *
 * @param  {Number} props.iconSize
 * How big should the icon be?
 */
var NoData = function NoData(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      theme = _ref.theme,
      iconSize = _ref.iconSize;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('NoData', theme && 'NoData--theme-' + theme, className) },
    _react2.default.createElement(
      'div',
      null,
      typeof icon === 'string' ? _react2.default.createElement(_Icon2.default, { name: icon, size: iconSize }) : icon // in case it's an Icon element

    ),
    _react2.default.createElement(
      'div',
      { className: 'NoData__content' },
      children || 'Nothing to display.. yet!'
    )
  );
};

NoData.defaultProps = {
  icon: 'flag-checkered',
  iconSize: 64
};

NoData.propTypes = {
  children: _propTypes2.default.node,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  iconSize: _propTypes2.default.number,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.string
};

exports.default = NoData;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/NoData/index.js
// module id = 621
// module chunks = 0